import { memo } from 'react';
import { LABEL } from '@veriables';
import style from '@components/checksCommon/checksCart.module.scss';

const CartTabs = ({
  activeTab,
  setActiveTab,
  pendingCount,
  sentCount,
  tabStyles,
  allChecked,
  toggleAll,
  hasItems,
  serverAppTheme,
}) => (
  <div className="d-flex m-0 p-0 pt-1 h-10">
    <div className="col-12 px-0 d-flex justify-content-center h-85 pl-1">
      <div
        className="p-0 m-0 d-flex justify-content-center align-items-center"
        style={{ minWidth: '28px', width: '28px' }}
      >
        {hasItems && (
          <input
            type="checkbox"
            checked={allChecked}
            onChange={e => toggleAll(e.target.checked)}
            className={style.checkbox}
            style={{
              border: allChecked ? 'none' : serverAppTheme?.checkbox_border,
              '--checkbox-checked-color': serverAppTheme?.checkbox_check_color,
              '--checkbox-checked-bg': serverAppTheme?.checkbox_checked,
            }}
          />
        )}
      </div>
      <div className="row mx-0 px-0 rounded w-100">
        <div
          role="button"
          className="h-100 col row mx-0 justify-content-center p-0 py-1 position-relative fw-600 rounded-left border-right-0"
          style={
            activeTab === 'pending' || pendingCount > 0
              ? tabStyles.pendingTabBg
              : tabStyles.inactiveTabBg
          }
          onClick={() => setActiveTab('pending')}
        >
          <div className="col p-0 text-center d-flex align-items-center justify-content-center h-100 fs_12">
            {LABEL().PENDING} ({pendingCount})
          </div>
        </div>
        <div
          role="button"
          className="h-100 col row mx-0 justify-content-center p-0 py-1 position-relative fw-600 rounded-right"
          style={
            activeTab === 'sent'
              ? tabStyles.sentTabBg
              : tabStyles.inactiveTabBg
          }
          onClick={() => setActiveTab('sent')}
        >
          <div className="col p-0 text-center d-flex align-items-center justify-content-center h-100 fs_12">
            {LABEL().SENT} ({sentCount})
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default memo(CartTabs);
